import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-submenu-ex',
  templateUrl: './submenu-ex.component.html',
  styleUrls: ['./submenu-ex.component.scss']
})
export class SubmenuExComponent implements OnInit {

  constructor() {

  }

  ngOnInit() {
  }

}
